export const env = {
  client_id: import.meta.env.VITE_CLIENT_ID ?? "react_standalone_pos_spa",

  get clientId() {
    return this.client_id;
  },

  // ------------ Auth -------------
  authServer:
    import.meta.env.VITE_AUTH_SERVER ??
    "https://dev.accountservice.logevo.store",
  authApiBase:
    import.meta.env.VITE_AUTH_API_BASE ??
    "https://dev.authservice.logevo.store/api",
  scope:
    import.meta.env.VITE_AUTH_SCOPE ??
    "openid profile email api.read offline_access",

  // ------------ API endpoints -------------
  posBaseUrl:
    import.meta.env.VITE_POS_BASE_URL ??
    "https://dev.posservice.logevo.store/api/v1",
  itemBaseUrl:
    import.meta.env.VITE_ITEM_BASE_URL ??
    "https://dev.itemconfigservice.logevo.store/api/v1",
  salesBaseUrl:
    import.meta.env.VITE_SALE_BASE_URL ??
    "https://dev.salesservice.logevo.store/api/v1",
  salesInvoiceBaseUrl:
    import.meta.env.VITE_SALES_INVOICE_BASE_URL ??
    "https://dev.salesinvoiceservice.logevo.store/api/v1",
  sharedConfigBaseUrl:
    import.meta.env.VITE_SHARED_CONFIG_BASE_URL ??
    "https://dev.sharedconfigservice.logevo.store/api/v1",
  discountBaseUrl:
    import.meta.env.VITE_DISCOUNT_BASE_URL ??
    "https://dev.discountservice.logevo.store/api/v1",
  inventoryBaseUrl:
    import.meta.env.VITE_INVENTORY_BASE_URL ??
    "https://dev.inventoryservice.logevo.store/api/v1",
};
